import { useId } from 'react';
import { SearchSelect } from '../../components/ui/search-select';

// Render choices inside the page: native select popups can close immediately in embedded browsers.
export function RecordChoiceFilter({ label, accessibleLabel = label, value, onChange, options }: {
  label: string; accessibleLabel?: string; value: string; onChange: (value: string) => void; options: Record<string, string>;
}) {
  const id = useId();
  return <div className="field record-choice-filter"><label htmlFor={id}>{label}</label>
    <SearchSelect id={id} label={accessibleLabel} value={value} onChange={onChange}
      searchable={false} includeEmpty={false} options={Object.entries(options).map(([id, name]) => ({ id, name }))} />
  </div>;
}
